<template style="position: relative">
  <!-- Modal -->
  <div class="shadow">

  </div>
  <div class="background defaultLayout">

    <!-- Nav -->
    <NavMenu @updateTitle="updateTitle" />
    <!-- CONTENT -->
    <div class="pageContent">
      <!-- Title -->
      <h1 class="titleHolder">{{ pTitle }}</h1>
      <!-- CONTENT: dependant -->
      <div class="contentBox">
        <router-view @updateTitle="updateTitle" />
      </div>

      <!-- Mobile Footer -->
      <div class="footer miniContact">
        <p>Jennifer Baldwin</p>
        <p class="boring">&copy;2025 All rights reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
import NavMenu from "./components/NavMenu.vue";

export default {
  name: "App",
  components: {
    NavMenu,
  },
  data() {
    return {
      pTitle: "home",
    };
  },
  methods: {
    updateTitle(pageTitle) {
      console.log("old Title: ", this.pTitle);
      this.pTitle = pageTitle;
      console.log("new Title: ", this.pTitle);
    },
  },
};
</script>

<style>
/* Base Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin-bottom: 16px;
}

/* END Base Reset */
/* Import Fonts */
@font-face {
  font-family: "besterReg";
  src: url(assets/fonts/BestermindRegular.ttf);
}

@font-face {
  font-family: "typeReg";
  src: url(assets/fonts/typewcond_regular.otf);
}

@font-face {
  font-family: "typeBld";
  src: url(assets/fonts/typewcond_bold.otf);
}

@font-face {
  font-family: "typeDmi";
  src: url(assets/fonts/typewcond_demi.otf);
}

/* END Import Fonts */

/* Default Layout */
.defaultLayout {
  /* alignment */
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  position: relative;
}

.defaultLayout .pageContent {
  flex-direction: column;
  padding: 30px 0 60px;
}

/* pageTitle */
.defaultLayout .pageContent .titleHolder {
  /* font and casing */
  font-size: 8vw;
  font-family: "besterReg";
  text-transform: capitalize;
}

.defaultLayout .pageContent .contentBox {
  /* Size */
  min-height: 55vh;
  height: fit-content;
  width: 65vw;
  padding: 35px;
  /* mount */
  position: relative;
  /* style */
  background: linear-gradient(217deg, rgba(67, 48, 75, 0.7), rgba(255, 0, 0, 0.05) 70.71%), linear-gradient(127deg, rgba(67, 48, 75, 0.75), rgba(0, 255, 0, 0.05) 70.71%), linear-gradient(336deg, rgba(67, 48, 75, 0.8), rgba(0, 0, 255, 0.05) 70.71%);
  border-radius: 30px;
  /* content alignment */
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}

.defaultLayout .pageContent .contentBox .pageIntro {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
}

.defaultLayout .pageContent .contentBox .pageIntro h2 {
  font-size: 50px;
  margin-bottom: 0px;
}

.defaultLayout .pageContent .contentBox .pageIntro h3 {
  font-family: "typeBld";
  font-size: 30px;
}

.defaultLayout .pageContent .contentBox .pageIntro .row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -30px;
}

.defaultLayout .pageContent .contentBox .pageIntro .row .name {
  /* placement */
  padding-left: 5%;
  rotate: -8deg;
  /* font */
  font-size: 48px;
  font-family: "besterReg";
  text-transform: capitalize;
  text-align: center;
  /* style */
  filter: drop-shadow(0 0 15px rgb(255, 255, 255));
}

.defaultLayout .pageContent .contentBox .pageIntro .niches {
  /* alignment */
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* spacing */
  padding-left: 25px;
  width: 65%;
}

.defaultLayout .footer {
  /* size and spacing */
  margin-top: 25px;
  margin-bottom: 15px;
  width: 100%;
  /* alignment */
  display: none;
  align-items: start;
  justify-content: start;
  flex-direction: column;
  /* font */
  font-size: 20px;
  font-family: "typeBld";
  filter: drop-shadow(0px 0px 3px rgb(240, 240, 255));
  color: rgba(0, 0, 0, 1);
  cursor: default;
}

.defaultLayout .footer p {
  margin-bottom: 5px;
}

.defaultLayout .footer p:first-child {
  font-size: 30px;
}

.defaultLayout .footer p:last-child {
  margin-bottom: 0;
}

/* small desktop */
@media only screen and (max-width: 1350px) {
  .defaultLayout .pageContent .contentBox .pageIntro .niches {
    width: 100%;
  }
}

/* Tablet */
@media only screen and (max-width: 915px) {
  .defaultLayout {
    flex-direction: column;
    align-items: center;
  }

  .defaultLayout .pageContent {
    margin-top: 18vh;
    padding: 15px 0;
    margin-top: 12%;
  }

  .defaultLayout .pageContent .titleHolder {
    margin-bottom: 0px;
    font-size: 12vw;
  }

  .defaultLayout .pageContent .contentBox {
    width: 85vw;
    min-height: 45vh;
    height: fit-content;
  }

  .defaultLayout .pageContent .contentBox .pageIntro h2 {
    font-size: 35px;
  }

  .defaultLayout .pageContent .contentBox .pageIntro .niches h3 {
    font-size: 24px;
  }

  .defaultLayout .pageContent .footer {
    display: flex;
  }
}

/* Mobile */
@media only screen and (max-width: 560px) {
  .defaultLayout .pageContent {
    margin-top: 80px;

  }

  .defaultLayout .pageContent .titleHolder {
    font-size: 15vw;
  }

  .defaultLayout .pageContent .contentBox {
    width: 90vw;
    padding: 20px;
    margin-bottom: 15px;
  }

  .defaultLayout .pageContent .contentBox .pageIntro h2 {
    font-size: 28px;
  }

  .defaultLayout .pageContent .contentBox .pageIntro .row {
    margin-top: -20px;
  }

  .defaultLayout .pageContent .contentBox .pageIntro .row h3 {
    font-size: 20px;
  }

  .defaultLayout .pageContent .contentBox .pageIntro .row .name {
    font-size: 38px;
  }

  .defaultLayout .pageContent .contentBox .pageIntro .niches {
    padding-left: 0;
  }

  .defaultLayout .pageContent .contentBox .pageIntro .niches h3 {
    font-size: 18px;
  }

  .defaultLayout .pageContent .contentBox .contentHolder {
    height: fit-content;
    overflow: visible;
  }
}

/* END Default Layout */

/* Background Styles */
.background {
  /* size */
  min-height: 100vh;
  /* background image and placement */
  background-image: linear-gradient(45deg, rgba(205, 92, 92, 0.7), rgba(169, 92, 205, 0.5), rgba(205, 160, 92, 0.9)), url(assets/images/background.jpg);
  background-position: top;
  background-repeat: none;
  background-size: cover;
  background-attachment: fixed;
  /* mount for position fixed */
  position: relative;
}

/* END Background Styles */
</style>
